require('../../../../Assets/Media/dr.kahl-dr.koch-metz-logo.svg');
